/**
 * Referral cookie — 30-day window between clicking an Ambassador's
 * `/join/{slug}` link and actually signing up / logging back in.
 *
 * Contract:
 *   • `dropReferralCookie(slug)` — set on the /join/{slug} page load.
 *   • `getReferralCookie()`     — read from anywhere (signup, login).
 *   • `clearReferralCookie()`   — call once attribution is stamped on
 *                                 the user so the cookie doesn't linger
 *                                 and steal a later ambassador's credit.
 *
 * Not HttpOnly because the frontend needs to read it for auto-attribution
 * on the signup form. Not a security surface — it's just a marketing
 * attribution hint. The backend still enforces slug validity + one-way
 * attribution (never overrides an existing `affiliate_id`).
 */

const COOKIE_NAME = 'ox_ref_slug';
const MAX_AGE_DAYS = 30;

export function dropReferralCookie(slug) {
  if (!slug || typeof slug !== 'string') return;
  const clean = slug.trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
  if (!clean) return;
  const maxAge = MAX_AGE_DAYS * 24 * 60 * 60; // seconds
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(clean)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
}

export function getReferralCookie() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]+)`));
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

export function clearReferralCookie() {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax${secure}`;
}
